import React, {useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import Button from '@pb/kit-component-button';

export const CreateConferenceButton = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();

    const handler = useCallback(() => {
        navigate('/create-new-conference');
    }, [navigate]);

    return (
        <Button variant="Type.SECONDARY" onClick={handler} disabled={pathname === '/create-new-conference'}>
            Create Conference
        </Button>
    );
};
